import { NativeSelect, useMantineColorScheme } from "@mantine/core";
import { useEffect, useState } from "react";

type BooleanFormSelectProps<T extends Record<string, any>> = {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  placeholder?: string;
  readonlyMode?: boolean;
  disabled?: boolean;
  styles?: React.CSSProperties;
};

const BooleanFormSelect = <T extends Record<string, any>>({
  label = "Select",
  value = false,
  onChange,
  readonlyMode = false,
  disabled = false,
  styles,
}: BooleanFormSelectProps<T>) => {
  const initial = value ? "true" : "false";
  const [localValue, setLocalValue] = useState<string>(initial);

  const { colorScheme } = useMantineColorScheme();
  const isDark = colorScheme === "dark";

  useEffect(() => {
    setLocalValue(value ? "true" : "false");
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const val = e.target.value;
    setLocalValue(val);
    onChange(val === "true");
  };

  return (
    <NativeSelect
      label={label}
      value={localValue}
      onChange={handleChange}
      disabled={disabled || readonlyMode}
      data={[
        { value: "true", label: "Yes" },
        { value: "false", label: "No" },
      ]}
      styles={{
        input: {
          backgroundColor: readonlyMode
            ? "#f5f5f5"
            : isDark
              ? "#3a3a3a"
              : "white",

          borderColor: readonlyMode
            ? "lightgray"
            : isDark
              ? "#4dabf7"
              : "#228be6",

          color: "inherit",
          opacity: 1,
          transition: "background-color 120ms ease, border-color 120ms ease",
        },
        ...styles,
      }}
    />
  );
};

export default BooleanFormSelect;
